import useStep1 from '../../../application/bloc/useStep1';
import useKeypad from '../../../application/hooks/useKeypad';
import { HeadTitle, Spacer, SsnTextField, NumberPad, Button, Popup } from 'oui';
import { SideBox, FloatingBox } from '../../etc/LBox/LBox';
import { MEDIA_NAME } from '../../../application/types/types';
import { isIOS } from 'react-device-detect';
import KTIOSWarning from '../../component/KtIOSWarning';

const Step1 = () => {
  const {
    media,
    personal,
    openKeypad,
    ssnWarning,
    setKeypad,
    checkUserCert,
    navigate,
    openAlert,
    setAlert,
    inputKeys,
    inputNumber,
    deleteNumber,
    isValidation,
  } = useStep1();
  const { keypad } = useKeypad();

  const handleClickAlert = () => {
    setAlert(false);
    navigate('/main');
  };

  return (
    <>
      <HeadTitle textTitle={'주민등록번호 뒷자리를\n 입력해주세요'} />
      <Spacer size={'lg'} />
      <SideBox>
        <SsnTextField
          onClickSsnTextField={() => setKeypad(true)}
          warning={ssnWarning}
          informKeys={personal?.birthDt?.substring(2)}
          selectedKeys={inputKeys}
          focused={openKeypad}
        />
      </SideBox>

      <NumberPad
        isOpen={openKeypad}
        onClickNumber={inputNumber}
        onClickDeleteNumber={deleteNumber}
        onClickCloseNumberPad={() => setKeypad(false)}
        numberList={keypad}
      />

      <FloatingBox>
        <Button
          flexible={true}
          configuration={'contained'}
          onClick={checkUserCert}
          state={isValidation ? 'enabled' : 'disabled'}
          children={'다음'}
          isDisabled={!isValidation}
        />
      </FloatingBox>

      <Popup
        isPopupOpen={openAlert}
        title={'인증 횟수가 초과되었어요!\n 다시 시도해주세요'}
        confirmBtn={{ text: '확인', onClick: handleClickAlert }}
      />
    </>
  );
};

export default Step1;
